'use client';

import { memo, useEffect } from 'react';
import { bootBiff } from '@/app/common/biff/biffLoader.ts';

type BiffBootstrapProps = {
  isDev: boolean;
  isLocal: boolean;
};

/**
 * Injects the biff (ads) script on first commit, for every page type and before any cookie consent: biff
 * itself waits for GTM's LMN_COOKIES_GO signal before running ads. Unconditional on purpose, as the search page
 * always was: the app webview, bots and white labels get the script too (biff ignores white labels itself), and
 * only the hotel detail page skips its ads on a slow connection (HotelDetailBiff). Pages then request their
 * configuration and slots through biffLoader (HotelDetailBiff, initBiffSearchPage).
 */
const BiffBootstrapComponent = ({ isDev, isLocal }: BiffBootstrapProps) => {
  // Mount-only on purpose: the script is injected once per page.
  useEffect(() => {
    bootBiff({ isDev, isLocal });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export const BiffBootstrap = memo(BiffBootstrapComponent);
